import * as types from './_actionTypes';

// Fetch SMEs actions
export const fetchSMEsRequest = (params = {}) => ({
  type: types.FETCH_SMES_REQUEST,
  payload: params
});

export const fetchSMEsSuccess = (smes) => ({
  type: types.FETCH_SMES_SUCCESS,
  payload: smes
});

export const fetchSMEsFailure = (error) => ({
  type: types.FETCH_SMES_FAILURE,
  payload: error
});

// Create SME actions
export const createSMERequest = (smeData) => ({
  type: types.CREATE_SME_REQUEST,
  payload: smeData
});

export const createSMESuccess = (sme) => ({
  type: types.CREATE_SME_SUCCESS,
  payload: sme
});

export const createSMEFailure = (error) => ({
  type: types.CREATE_SME_FAILURE,
  payload: error
});

// Delete SME actions
export const deleteSMERequest = (smeId) => ({
  type: types.DELETE_SME_REQUEST,
  payload: smeId
});

export const deleteSMESuccess = (smeId) => ({
  type: types.DELETE_SME_SUCCESS,
  payload: smeId
});

export const deleteSMEFailure = (error, smeId) => ({
  type: types.DELETE_SME_FAILURE,
  payload: { error, smeId }
});

// Update SME actions
export const updateSMERequest = (smeId, updateData) => ({
  type: types.UPDATE_SME_REQUEST,
  payload: { smeId, updateData }
});

export const updateSMESuccess = (sme) => ({
  type: types.UPDATE_SME_SUCCESS,
  payload: sme
});

export const updateSMEFailure = (error) => ({
  type: types.UPDATE_SME_FAILURE,
  payload: error
});